import {
  Box,
  Button,
  Divider,
  Link,
  Menu,
  Paper,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import AlmaLogo from '../../resources/CompanyLogo.svg?react';
import { AccountMenu } from '@ailex/react-components';
import { useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';
import { externalLegalInsightsLinks } from '../../utilities/Links';
import { useAuth } from '../Auth/AuthProvider';

function JuridiikkaMenu() {
  const { t } = useTranslation();
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorElement);

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  return (
    <>
      <Button
        variant='text'
        size='small'
        onClick={handleButtonClick}
        endIcon={
          <Stack
            sx={{
              marginLeft: -1,
            }}
          >
            <ArrowDropDownIcon fontSize='small' />
          </Stack>
        }
        sx={{
          color: 'text.secondary',
          fontSize: '12px',
          '&:hover': { textDecoration: 'underline', backgroundColor: 'unset' },
        }}
        aria-controls={open ? 'juridiikka-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
      >
        {t('almaHeader.dropdownMenuTitle')}
      </Button>
      {open && (
        <Menu
          id='juridiikka-menu'
          anchorEl={anchorElement}
          open={open}
          onClose={handleClose}
          slotProps={{
            list: {
              'aria-labelledby': 'juridiikka-menu-button',
            },
          }}
          sx={{ zIndex: 1301 }}
        >
          <Stack direction='column'>
            {externalLegalInsightsLinks.map((link, index) => {
              return (
                <Box
                  key={'juridiikka-menu-' + link.id}
                  sx={{
                    width: '100%',
                  }}
                >
                  <Link
                    href={link.href}
                    sx={{
                      fontWeight: 'normal',
                      fontSize: '12px',
                      lineHeight: '100%',
                      color: 'text.secondary',
                      display: 'block',
                      textDecoration: 'none',
                      '&:hover': {
                        textDecoration: 'underline',
                        backgroundColor: 'rgba(70, 122, 77, 0.08)',
                      },
                      paddingX: 2,
                      paddingY: 1,
                      width: '100%',
                    }}
                    target='_blank'
                  >
                    {link.label}
                  </Link>
                  {externalLegalInsightsLinks.length !== index + 1 && (
                    <Divider />
                  )}
                </Box>
              );
            })}
          </Stack>
        </Menu>
      )}
    </>
  );
}

const links = [
  {
    label: 'Bisneskirjasto',
    href: 'https://bisneskirjasto.almatalent.fi/bisneskirjasto#Bisneskirjasto',
  },
  { label: 'Alma kirjakauppa', href: 'https://kirjakauppa.almainsights.fi/' },
];

export default function AlmaHeader() {
  const theme = useTheme();
  const showLinks = useMediaQuery(theme.breakpoints.up('md'));
  const identity = useAuth();

  return (
    <Paper elevation={0} sx={{ zIndex: 1301 }}>
      <Stack
        direction='row'
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          height: '32px',
          paddingX: 2,
        }}
      >
        <Stack sx={{ paddingY: 1 }}>
          <AlmaLogo data-testid='alma-talent-logo' height={16} width={58} />
        </Stack>

        {showLinks && (
          <Stack
            direction='row'
            useFlexGap
            sx={{
              alignItems: 'center',
              gap: 3,
              justifyContent: 'start',
            }}
          >
            <JuridiikkaMenu />
            {links.map((link) => {
              return (
                <Link
                  key={'alma-header-' + link.label}
                  href={link.href}
                  sx={{
                    fontWeight: 'normal',
                    fontSize: '12px',
                    lineHeight: '100%',
                    color: 'text.secondary',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                  target='_blank'
                >
                  {link.label}
                </Link>
              );
            })}
          </Stack>
        )}

        <AccountMenu identityContext={identity} />
      </Stack>
    </Paper>
  );
}
